<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <image-row :title="topTitle" config="page-home" />
      </v-row>
      <div class="vision-wrapper">
        <div class="vision-content">
          <div class="vision-title-wrapper">
            <span class="vision-title">{{ visionTitle }}</span>
          </div>
          <div class="vision-text-wrapper">
            <span class="vision-text" v-html="visionText" />
          </div>
          <div class="vision-logos-wrapper">
            <img class="vision-logo" src="https://storage.googleapis.com/mwm-website-v2-content/logo-frenchtech.png" />
            <img class="vision-logo" src="https://storage.googleapis.com/mwm-website-v2-content/logo-bpi-france.png" />
            <img class="vision-logo" src="https://storage.googleapis.com/mwm-website-v2-content/logo-francedigitale.png" />
          </div>
        </div>
      </div>
      <v-row no-gutters justify="center" class="ecosystem-parent">
        <div class="ecosystem-background ecosystem-child" />
        <div class="ecosystem-card ecosystem-child">
          <div class="ecosystem-title-wrapper">
            <span class="ecosystem-title">{{ ecosystemTitle }}</span>
          </div>
          <div class="ecosystem-text-wrapper">
            <div class="ecosystem-text" v-html="ecosystemText" />
          </div>
          <div class="ecosystem-logos-wrapper">
            <v-row v-if="!isMobile" no-gutters justify="space-around">
              <v-spacer />
              <v-col cols="2" class="ecosystem-logos-card" v-for="logo in ecosystemLogos" :key="logo.key">
                <img class="ecosystem-logo" :src="logo.src" />
                <div class="ecosystem-logo-text-wrapper">
                  <span class="ecosystem-logo-text" v-html="logo.text" />
                </div>
              </v-col>
              <v-spacer />
            </v-row>
            <v-row v-else no-gutters>
              <v-col cols="12">
                <v-row no-gutters justify="space-around">
                  <v-spacer />
                  <v-col cols="5" class="ecosystem-logos-card">
                    <img class="ecosystem-logo" :src="ecosystemLogos[0].src" />
                    <div class="ecosystem-logo-text-wrapper">
                      <span class="ecosystem-logo-text" v-html="ecosystemLogos[0].text" />
                    </div>
                  </v-col>
                  <v-col cols="5" class="ecosystem-logos-card">
                    <img class="ecosystem-logo" :src="ecosystemLogos[1].src" />
                    <div class="ecosystem-logo-text-wrapper">
                      <span class="ecosystem-logo-text" v-html="ecosystemLogos[1].text" />
                    </div>
                  </v-col>
                  <v-spacer />
                </v-row>
                <v-row class="mt-5" no-gutters justify="space-around">
                  <v-spacer />
                  <v-col cols="5" class="ecosystem-logos-card">
                    <img class="ecosystem-logo" :src="ecosystemLogos[2].src" />
                    <div class="ecosystem-logo-text-wrapper">
                      <span class="ecosystem-logo-text" v-html="ecosystemLogos[2].text" />
                    </div>
                  </v-col>
                  <v-col cols="5" class="ecosystem-logos-card">
                    <img class="ecosystem-logo" :src="ecosystemLogos[3].src" />
                    <div class="ecosystem-logo-text-wrapper">
                      <span class="ecosystem-logo-text" v-html="ecosystemLogos[3].text" />
                    </div>
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-col>
            </v-row>
          </div>
          <div class="ecosystem-button-wrapper">
            <v-btn :ripple="false" height="54" class="ecosystem-button" @click="goto('/apps')">
              <span class="ecosystem-button-text">See our apps</span>
            </v-btn>
          </div>
        </div>
      </v-row>
      <v-row no-gutters class="patchwork">
        <v-img v-if="isMobile" eager src="https://storage.googleapis.com/mwm-website-v2-content/home/home-patchwork-mobile.jpg" />
        <v-img v-else eager src="https://storage.googleapis.com/mwm-website-v2-content/home/home-patchwork.png" />
      </v-row>
      <v-row v-if="isMobile" no-gutters class="join-parent">
        <div class="join-top-mobile">
          <div class="join-top-title-wrapper-mobile">
            <span class="join-top-title" v-html="joinTopTitle" />
          </div>
          <div class="join-top-text-wrapper-mobile">
            <span class="join-top-text" v-html="joinTopText" />
          </div>
          <div class="join-top-button-wrapper">
            <v-btn :ripple="false" height="54" class="join-top-button" @click="goto('/career')">
              <span class="join-top-button-text">{{ joinTopButtonText }}</span>
            </v-btn>
          </div>
        </div>
        <!-- <div> -->
          <v-img class="join-bottom-mobile" src="https://storage.googleapis.com/mwm-website-v2-content/home/mwm-team.jpg" />
        <!-- </div> -->
      </v-row>
      <v-row v-else no-gutters class="join-parent">
        <div class="join-top join-child">
          <div class="join-top-texts-wrapper">
            <span class="join-top-title" v-html="joinTopTitle" /><br/>
            <div class="join-top-text-wrapper">
              <span class="join-top-text" v-html="joinTopText" />
            </div><br/>
            <div class="join-top-button-wrapper">
              <v-btn :ripple="false" height="54" class="join-top-button" @click="goto('/career')">
                <span class="join-top-button-text">{{ joinTopButtonText }}</span>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="join-bottom join-child">

        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SizeHolder from '@/mixins/SizeHolder.vue';

import { mapGetters } from 'vuex';

import ImageRow from './components/ImageRow.vue'

export default {
  mixins: [SizeHolder],
  components: {
    'image-row': ImageRow,
  },
  data: () => ({
    topTitle: 'The world’s leading<br/>creative apps publisher',

    visionTitle: 'We have one vision : Creativity for all',
    visionText: 'MWM has always had at heart to free one\'s creativity. Through various and complementary apps, we offer to everyone the means to express their imagination.<br /><br />MWM is known to be a French Tech champion, supported by the key actors of the Tech sector.',

    ecosystemTitle: 'More than a few apps, an ecosystem',
    ecosystemText: 'Within the last 6 years, MWM has developed more than 15 apps covering all the main Creation segment including Music Production, Music Learning, Gaming or Utilities.<br /><br />We are proud to be at the origin of best-selling apps such as edjing Mix, the most downloaded DJ app in the world, but also huge successes like the suite of learning apps Guitar, Piano or Drums.',
    ecosystemLogos: [
      { key: 'download', text: '400M<br />downloads', src: 'https://storage.googleapis.com/mwm-website-v2-content/ecosystem-download.svg' },
      { key: 'publisher', text: '#1<br />creative apps publisher worldwide', src: 'https://storage.googleapis.com/mwm-website-v2-content/ecosystem-publisher.svg' },
      { key: 'applications', text: '15+<br />applications', src: 'https://storage.googleapis.com/mwm-website-v2-content/ecosystem-apps.svg' },
      { key: 'countries', text: '182<br />countries', src: 'https://storage.googleapis.com/mwm-website-v2-content/ecosystem-countries.svg' },
    ],

    joinTopTitle: 'Join the team',
    joinTopText: 'Join us and become a part of our<br />creative adventure!',
    joinTopButtonText: 'See jobs',
    jobsUrl: 'https://www.welcometothejungle.com/fr/companies/mwm/jobs',
  }),
  methods: {
    goto (route) {
      this.$router.push(route)
    },
    openUrl (url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
  },
  mounted () {

  }
};
</script>

<style scoped lang="scss">
@media (max-width: 1260px) {

}

@media (max-width: 1024px) {
  .vision-wrapper {
    width: 90%!important;
  }

  .ecosystem-card {
    width: 85%!important;
  }

  .ecosystem-button-wrapper {
    margin-top: 3rem!important;
  }
}

@media (max-width: 960px) {
  .patchwork {
    padding-top: 5rem!important;
  }

  .ecosystem-title {
    font-size: 22px!important;
    line-height: 1.2!important;
  }

  .ecosystem-text-wrapper {
    width: 80%!important;
  }

  .ecosystem-text {
    font-size: 16px!important;
    font-weight: 400!important;
    line-height: 1.6!important;
  }

  .ecosystem-logo-text-wrapper {
    margin-left: 0.2rem!important;
    margin-right: 0.2rem!important;
  }

  .join-parent {
    margin-bottom: 0rem!important;
    height: unset!important;
  }

  .vision-wrapper {
    width: 90%!important;
  }

  .vision-title-wrapper {
    margin-top: 2rem!important;
    width: 100%!important;
  }

  .vision-title {
    font-size: 26px!important;
  }

  .vision-text-wrapper {
    width: 95%!important;
  }

  .vision-text {
    font-size: 1rem!important;
  }

  .vision-logo {
    height: 75px!important;
    width: auto;
    margin-left: 0rem!important;
    margin-right: 0rem!important;
  }
}

@media (max-width: 767px) {
  .patchwork {
    padding-top: 10rem!important;
  }

  .vision-logos-wrapper {
    padding-bottom: 2rem!important;
  }

  .vision-logo {
    height: 50px!important;
    margin-left: 0.5rem!important;
    margin-right: 0.5rem!important;
  }
}

@media (max-width: 567px) {
  .ecosystem-logos-card {
    margin-left: 0.5rem!important;
    margin-right: 0.5rem!important;
  }

  .patchwork {
    padding-top: 20rem!important;
  }
}

.vision-wrapper {
  display: table;
  width: 80%;
  height: 55vh;
  margin-right: auto;
  margin-left: auto;
}

.vision-content {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.vision-title-wrapper {
  margin-bottom: 2rem;
  width: 65%;
  margin-left: auto;
  margin-right: auto;
}

.vision-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #0b142a;
}

.vision-text-wrapper {
  margin-bottom: 2rem;
  width: 65%;
  margin-left: auto;
  margin-right: auto;
}

.vision-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #0b142a;
}

.vision-logos-wrapper {
  margin-top: 2rem;
}

.vision-logo {
  height: 87px;
  width: auto;
  margin-left: 1rem;
  margin-right: 1rem;
}

.ecosystem-card {
  position: absolute;
  margin-top: 8rem;
  padding-bottom: 3rem;
  width: 65%;
  border-radius: 26px;
  box-shadow: 0 11px 44px 0 rgba(0, 0, 0, 0.3);
  background-color: #fdfdff;
  text-align: center;
}

.ecosystem-title-wrapper {
  margin-top: 4rem;
}

.ecosystem-title {
  font-family: CenturyGothic;
  font-size: 30px;
  font-weight: bold;
  line-height: 2.33;
  text-align: center;
  color: #212a39;
}

.ecosystem-text-wrapper {
  margin-top: 2rem;
  width: 75%;
  margin-left: auto;
  margin-right: auto;
}

.ecosystem-text {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.67;
  text-align: center;
  color: #212a39;
}

.ecosystem-background {
  height: 705px;
  width: 100%;
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/home/ecosystem-bg.jpg);
  background-size: cover;
  background-position: center center;
}

.ecosystem-parent {
  // height: 80vh;
  position: relative;
  margin-bottom: 14rem;
}

.ecosystem-child {
  // position: absolute;
}

.ecosystem-logos-wrapper {
  margin-top: 2rem;
}

.ecosystem-logos-card {
  padding: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  border-radius: 26px;
  box-shadow: 0 7px 28px 0 rgba(0, 0, 0, 0.25);
  background-color: #fdfdff;
}

.ecosystem-logo {
  margin-top: 1rem;
  margin-bottom: 0.25rem;
  margin-left: 1rem;
  margin-right: 1rem;
  width: 3rem;
  height: 3rem;
}

.ecosystem-logo-text-wrapper {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  line-height: normal;
}

.ecosystem-logo-text {
  font-family: CenturyGothic;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.ecosystem-button-wrapper {
  margin-top: 4rem;
}

.ecosystem-button {
  width: 223px;
  text-transform: unset;
  border-radius: 27px;
  background-color: -webkit-gradient(linear, right top, left top, color-stop(104%, #8e0eb3), color-stop(4%, #0e25a9));
  background-image: linear-gradient(to right, #8e0eb3, #0e25a9);
}

.ecosystem-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fdfdff;
}

.patchwork {

}

.join-parent {
  height: 80rem;
  margin-bottom: 40rem;
  position: relative;
}

.join-child {
  position: absolute;
}

.join-top {
  margin-top: 10rem;
  width: 80%;
  height: 916px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  text-align: right;
  background-image: linear-gradient(to left, #ff7854 89%, #8e0eb3 6%);
  background-image: -webkit-gradient(linear, left top, right top, color-stop(89%, #ff7854), color-stop(6%, #8e0eb3));
}

.join-top-texts-wrapper {
  margin-top: 10rem;
  margin-right: 10rem;
}

.join-top-title {
  font-family: CenturyGothic;
  font-size: 74px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.join-top-text-wrapper {
  margin-top: 1rem;
}

.join-top-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: right;
  color: #ffffff;
}

.join-top-button-wrapper {
  margin-top: 2rem;
}

.join-top-button {
  width: 200px;
  height: 54px;
  border-radius: 27px;
  background-color: #ffffff;
  text-transform: unset;
  box-shadow: unset;
}

.join-top-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ec6663;
}

.join-bottom {
  height: 1000px;
  width: 90%;
  margin-top: 45rem;
  margin-left: 10%;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  background-image: url(https://storage.googleapis.com/mwm-website-v2-content/home/mwm-team.jpg);
  background-size: cover;
  object-fit: contain;
  background-position: center center;
}

.join-top-mobile {
  width: 100%;
  text-align: center;
  background-image: linear-gradient(228deg, #ff7854 71%, #8e0eb3 13%);
  background-image: -webkit-gradient(linear, left top, right top, color-stop(71%, #ff7854), color-stop(13%, #8e0eb3));
}

.join-top-mobile .join-top-title {
  padding-top: 4rem;
  font-family: CenturyGothic;
  font-size: 37px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.join-top-title-wrapper-mobile {
  margin-top: 8rem;
}

.join-top-text-wrapper-mobile {
  margin-top: 2rem;
}

.join-top-button-wrapper {
  padding-bottom: 4rem;
}

.join-bottom-mobile {
  // width: 960px;
  // position: relative;
  // left: 50%;
  // margin-left: -400px;
}

</style>
